module.exports = __webpack_public_path__ + "static/media/pp.9e619110.pdf";